export const formatNumberTwoDecimals = (value: Number): string => value.toFixed(2)
